export const dashboardsTxt = {
  DASHBOARDS_ARE_BEING_UPDATED: "Dashboards are being updated",
};
